<template>
  <hl-Select
    label="Bygg"
    v-model="building"
    :options="buildingOptions"
    placeholder="Velg bygg"
    placeholderValue="__default__"
  />
</template>

<script>
import FilterMixin from '@/components/reports/filters/FilterMixin';
import Select from '@modules/husleie-framework/src/components/forms/inputs/select/Select.vue';

export default {
  name: 'BuildingFilterItem',

  components: {
    'hl-Select': Select,
  },

  mixins: [FilterMixin],

  computed: {
    building: {
      get() {
        return this.getLocalSubValueOrDefault('building', '__default__');
      },
      set(v) {
        this.setLocalValue('building', v);
      },
    },
    buildingOptions() {
      const options = [];
      if (!this.meta.buildingIds) {
        return options;
      }
      const fromState = this.meta.buildingIds.map(buildingId => ({
        name: buildingId === '' ? '<ingen>' : buildingId,
        value: buildingId,
      }));
      return options.concat(fromState);
    },
  },
};
</script>

<style scoped lang="scss"></style>
